import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { styled, useTheme } from "@mui/material/styles";
import {
    Box,
    Button,
    FormControl,
    OutlinedInput,
    InputAdornment,
    Grid,
    Stack,
    TextField,
} from "@mui/material";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useState } from "react";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import customStyles from "app/shared-components/SelectCustomStyle";
import moment from "moment/moment";

const StyledTextField = styled(TextField)(({ theme }) => ({
    "& input": {
        padding: "10px 14px",
        height: '0.4375em',
    },
    ".muiltr-rboi0c-MuiInputBase-root-MuiOutlinedInput-root": {
        lineHeight: 0.7,
        minHeight: '25px',
    },
}));

const StyledOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
    "& input": {
        padding: "10px 14px",
        height: '0.4375em',
    },
    "&.MuiOutlinedInput-root": {
        lineHeight: 0.7,
        minHeight: '25px',
    }
}));

const StyledSelect = styled(Select)(({ theme }) => ({
    "&.MuiInputBase-root": {
        lineHeight: 1.5,
        minHeight: '27px',
    }
}))

const StatementFilter = (props) => {
    const { handleSearchInvoice, handleSearchCustomer, handleName, handleLoadingDate, handleSearchPeriod, handleDate, handleTeritory, handleCommissionName, handleOptionChange, handleSearch, toggleFullScreen } = props
    const [company, setCompany] = useState('')
    const [invoice, setInvoice] = useState('')
    const [customer, setCustomer] = useState();
    const [name, setName] = useState('');
    const [loadingDate, setLoadingDate] = useState('');
    const [period, setPeriod] = useState('');
    const [date, setDate] = useState('');
    const [teritory, setTeritory] = useState('');
    const [commissionName, setCommissionName] = useState('');
    const [selectedOption, setSelectedOption] = useState('View it date');
    const viewOptions = ['View it monthly', 'View it date'];

    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                <div className="flex">
                    <FormControl className="flex flex-row">
                        <Grid container spacing={2}>
                            <Grid item md={2} lg={2}>
                                <div className="mr-16">
                                    <label>Company</label>
                                    <StyledTextField type="text" variant="outlined" fullWidth name="company" value={company}
                                        onChange={(e) => { setCompany(e.target.value); }} />
                                </div>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <Stack>
                                    <label className="basis-0 float-left">Proforma Invoice</label>
                                    <TextField
                                        className="w-[100%]"
                                        type="text"
                                        name="invoice"
                                        value={invoice}
                                        onChange={(e) => { setInvoice(e.target.value); handleSearchInvoice(e.target.value) }}
                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <Stack>
                                    <label className="basis-0 float-left">Customer</label>
                                    <TextField
                                        className="w-[100%]"
                                        type="text"
                                        name="customerNo"
                                        placeholder="Customer No"
                                        value={customer}
                                        // onChange={(e) => { setAccountNo(e.target.value); handleChange(e) }}
                                        onChange={(e) => { setCustomer(e.target.value); handleSearchCustomer(e.target.value) }}
                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                                        // onChange={handle}
                                        InputProps={{ endAdornment: (<InputAdornment position="end"><FuseSvgIcon>heroicons-outline:search</FuseSvgIcon></InputAdornment>) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <Stack>
                                    <label className="basis-0 float-left">Name</label>
                                    <TextField
                                        className="w-[100%]"
                                        type="text"
                                        name="customerName"
                                        placeholder="Customer Name"
                                        value={name}
                                        // onChange={(e) => { setAccountNo(e.target.value); handleChange(e) }}
                                        onChange={(e) => { setName(e.target.value); handleName(e.target.value) }}
                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                                        // onChange={handle}
                                        InputProps={{ endAdornment: (<InputAdornment position="end"><FuseSvgIcon>heroicons-outline:search</FuseSvgIcon></InputAdornment>) }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <Stack>
                                    <label className="basis-0 float-left">Loading Date 123</label>
                                    <CustomDatePicker
                                        className="w-[100%]"
                                        format={'dd-MM-yyyy'}
                                        name={'loadingDate'}
                                        value={loadingDate}
                                        handleChange={async(value) => {
                                            setLoadingDate(moment(value).format('YYYY-MM-DD'));
                                            handleLoadingDate(moment(value).format('YYYY-MM-DD'))
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                size="small"
                                                InputLabelProps={{}}
                                                {...params}
                                                sx={{
                                                    backgroundColor: props.viewData && '#8080800f'
                                                }}
                                            />
                                        )}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <Stack>
                                    <label className="basis-0 float-left invisible">period </label>
                                    <CustomDatePicker
                                        className="w-[100%]"
                                        format={'dd-MM-yyyy'}
                                        name={'period'}
                                        value={period}
                                        handleChange={async(value) => {
                                            setPeriod(moment(value).format('YYYY-MM-DD'));
                                            handleSearchPeriod(moment(value).format('YYYY-MM-DD'))
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                size="small"
                                                InputLabelProps={{}}
                                                {...params}
                                                sx={{
                                                    backgroundColor: props.viewData && '#8080800f'
                                                }}
                                            />
                                        )}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <Stack>
                                    <label className="basis-0 float-left">Cutoff Date </label>
                                    <CustomDatePicker
                                        className="w-[100%]"
                                        format={'dd-MM-yyyy'}
                                        name={'date'}
                                        value={date}
                                        handleChange={async(value) => {
                                            setDate(moment(value).format('YYYY-MM-DD'));
                                            handleDate(moment(value).format('YYYY-MM-DD'))
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                size="small"
                                                InputLabelProps={{}}
                                                {...params}
                                                sx={{
                                                    backgroundColor: props.viewData && '#8080800f'
                                                }}
                                            />
                                        )}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <Stack>
                                    <label className="basis-0 float-left">Teritory</label>
                                    <TextField
                                        className="w-[100%]"
                                        type="text"
                                        name="Teritory"
                                        value={teritory}
                                        onChange={(e) => { setTeritory(e.target.value); handleTeritory(e.target.value) }}
                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <Stack>
                                    <label className="basis-0 float-left">Commission Name</label>
                                    <TextField
                                        className="w-[100%]"
                                        type="text"
                                        name="commisionName"
                                        value={commissionName}
                                        onChange={(e) => { setCommissionName(e.target.value); handleCommissionName(e.target.value) }}
                                        style={{ backgroundColor: "rgba(255, 255, 255, 0.12)" }}
                                    />
                                </Stack>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                <Stack>
                                    <label className=" basis-0 float-left">View Options</label>
                                    {/* <FormControl sx={{ width: 200 }} > */}
                                    <Select
                                        name="viewOptions"
                                        // value={selectedOption}
                                        value={(viewOptions.length > 0 && selectedOption) && viewOptions.find((data) => data === selectedOption)}
                                        // error={validError.currency ? true : false}
                                        onChange={(e) => { setSelectedOption(e.target.value); handleOptionChange(e.target.value) }}
                                        isDisabled={false}
                                        options={viewOptions}
                                        styles={customStyles()}
                                    >
                                    </Select>
                                </Stack>
                            </Grid>
                            <Grid item md={2} lg={2}>
                                {/* <div className="mr-16"> */}
                                {/* <label style={{ visibility: "hidden" }}>Period</label> */}
                                <Stack>
                                    <label style={{ visibility: "hidden" }}>Period</label>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        sx={{ height: "25px" }}
                                        onClick={() => handleSearch()}
                                    >
                                        <FuseSvgIcon>heroicons-outline:search</FuseSvgIcon>
                                    </Button>
                                </Stack>
                                {/* </div> */}
                            </Grid>
                            <Grid item md={2} lg={2}>
                                {/* <div className="mr-16"> */}
                                <Stack>
                                    <label style={{ visibility: "hidden" }}>Period</label>
                                    <Button
                                        variant="contained"
                                        color="warning"
                                        size="small"
                                        onClick={() => toggleFullScreen()}
                                        style={{ fontWeight: 'bold', height: "25px" }}
                                    >
                                        View Table
                                    </Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </FormControl>
                </div>
            </Box>
        </>
    )
}

export default StatementFilter;
